import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { sevkiyatService, cihazIDService } from '../api/dbService';
import PageLayout from '../components/PageLayout';

const INITIAL = {
  device_id: '', sevkiyat_adi: '', plaka: '',
  cikis_noktasi: '', varis_noktasi: '',
  surucu_adi: '', surucu_tel: '', urun: '',
  palet_sayisi: '', net_agirlik: '', brut_agirlik: '',
  sicaklik_min: '-5', sicaklik_maks: '10',
  tasiyici_id: '', notlar: ''
};

export default function ShipmentAdd() {
  const navigate = useNavigate();
  const [form, setForm] = useState(INITIAL);
  const [inaktifCihazlar, setInaktifCihazlar] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    cihazIDService.getInaktifCihazlar()
      .then(res => setInaktifCihazlar(res.data || []))
      .catch(() => {});
  }, []);

  function handleChange(e) {
    setForm(f => ({ ...f, [e.target.name]: e.target.value }));
  }

  async function handleSubmit(e) {
    e.preventDefault();
    if (!form.device_id) return toast.error('Cihaz seçimi zorunlu');
    setLoading(true);
    try {
      const res = await sevkiyatService.addSevkiyat(form);
      toast.success(`Sevkiyat oluşturuldu: ${res.sevkiyat_no}`);
      navigate('/');
    } catch (err) {
      toast.error(err.response?.data?.message || 'Sevkiyat oluşturulamadı');
    } finally {
      setLoading(false);
    }
  }

  return (
    <PageLayout>
      <div className="d-flex justify-content-between align-items-center mb-3">
        <h5 className="mb-0 fw-semibold">Yeni Sevkiyat Oluştur</h5>
        <button className="btn btn-outline-secondary btn-sm" onClick={() => navigate(-1)}>Geri</button>
      </div>

      <div className="card">
        <div className="card-body">
          <form onSubmit={handleSubmit}>
            <div className="row g-3">
              <div className="col-12 col-md-6">
                <label className="form-label small fw-semibold">Cihaz *</label>
                <select name="device_id" className="form-select" value={form.device_id} onChange={handleChange} required>
                  <option value="">-- Cihaz Seçin --</option>
                  {inaktifCihazlar.map(c => (
                    <option key={c.id} value={c.device_id}>
                      {c.cihaz_adi || c.device_id}
                    </option>
                  ))}
                </select>
              </div>
              <div className="col-12 col-md-6">
                <label className="form-label small fw-semibold">Sevkiyat Adı *</label>
                <input name="sevkiyat_adi" className="form-control" value={form.sevkiyat_adi} onChange={handleChange} required />
              </div>
              <div className="col-6">
                <label className="form-label small fw-semibold">Plaka</label>
                <input name="plaka" className="form-control" value={form.plaka} onChange={handleChange} />
              </div>
              <div className="col-6">
                <label className="form-label small fw-semibold">Ürün</label>
                <input name="urun" className="form-control" value={form.urun} onChange={handleChange} />
              </div>
              <div className="col-6">
                <label className="form-label small fw-semibold">Çıkış Noktası</label>
                <input name="cikis_noktasi" className="form-control" value={form.cikis_noktasi} onChange={handleChange} />
              </div>
              <div className="col-6">
                <label className="form-label small fw-semibold">Varış Noktası</label>
                <input name="varis_noktasi" className="form-control" value={form.varis_noktasi} onChange={handleChange} />
              </div>
              <div className="col-6">
                <label className="form-label small fw-semibold">Sürücü Adı</label>
                <input name="surucu_adi" className="form-control" value={form.surucu_adi} onChange={handleChange} />
              </div>
              <div className="col-6">
                <label className="form-label small fw-semibold">Sürücü Telefon</label>
                <input name="surucu_tel" className="form-control" value={form.surucu_tel} onChange={handleChange} />
              </div>
              <div className="col-4">
                <label className="form-label small fw-semibold">Min. Sıcaklık (°C)</label>
                <input type="number" name="sicaklik_min" className="form-control" value={form.sicaklik_min} onChange={handleChange} />
              </div>
              <div className="col-4">
                <label className="form-label small fw-semibold">Maks. Sıcaklık (°C)</label>
                <input type="number" name="sicaklik_maks" className="form-control" value={form.sicaklik_maks} onChange={handleChange} />
              </div>
              <div className="col-4">
                <label className="form-label small fw-semibold">Palet Sayısı</label>
                <input type="number" name="palet_sayisi" className="form-control" value={form.palet_sayisi} onChange={handleChange} />
              </div>
              <div className="col-12">
                <label className="form-label small fw-semibold">Notlar</label>
                <textarea name="notlar" className="form-control" rows="2" value={form.notlar} onChange={handleChange} />
              </div>
            </div>

            <div className="d-flex gap-2 mt-4">
              <button type="submit" className="btn btn-brand" disabled={loading}>
                {loading ? 'Oluşturuluyor...' : 'Sevkiyat Oluştur'}
              </button>
              <button type="button" className="btn btn-outline-secondary" onClick={() => setForm(INITIAL)}>
                Temizle
              </button>
            </div>
          </form>
        </div>
      </div>
    </PageLayout>
  );
}
